var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarpentry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "lt90uyk94a",
    d: "M0 0.739L20.7 0.739 20.7 4.5 0 4.5z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4A6354",
    d: "M12.01 17.822c-.038 0-.074-.008-.11-.022-.11-.044-.18-.15-.18-.265v-1.018l-3.058 1.257c-.108.044-.233.02-.316-.063-.083-.082-.108-.205-.063-.313l.394-.94-3.31.002c-.118 0-.224-.07-.269-.177-.045-.107-.02-.232.063-.314l.727-.72-3.06-1.251c-.108-.045-.179-.15-.179-.266 0-.117.07-.221.18-.266l.949-.39-2.343-2.316c-.083-.082-.108-.205-.063-.313.045-.107.151-.177.268-.177h1.028L1.4 7.242c-.045-.108-.02-.231.063-.314.083-.082.208-.106.316-.062l.95.39-.003-3.278c0-.116.071-.222.179-.267.109-.044.233-.02.317.063l.726.72 1.265-3.03c.045-.107.15-.178.269-.178.117 0 .222.07.267.178l.393.94 2.34-2.32c.082-.082.207-.107.316-.062.108.044.18.15.18.266v1.018L12.033.048c.108-.045.233-.02.316.063.083.082.108.206.063.313l-.393.94 3.31-.002c.117 0 .223.07.269.178.045.107.02.23-.063.313l-.728.719 3.06 1.253c.108.044.18.15.18.265 0 .116-.072.222-.18.266l-.95.39 2.317 2.29c.07.052.115.135.115.229 0 .159-.13.288-.29.288h-1.031l1.251 2.987c.027.044.044.095.044.15 0 .158-.13.288-.291.288h-.004c-.037 0-.075-.007-.111-.022l-.95-.39.003 3.232c.003.015.004.03.004.047 0 .159-.13.288-.29.288h-.004c-.075 0-.15-.03-.205-.085l-.727-.72-1.265 3.03c-.045.107-.15.178-.268.178-.118 0-.223-.07-.268-.178l-.393-.94-2.34 2.319c-.055.056-.13.085-.205.085"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D1E040",
    d: "M12.311 8.91c0 1.074-.878 1.943-1.961 1.943-1.084 0-1.961-.87-1.961-1.942 0-1.073.877-1.942 1.961-1.942 1.083 0 1.961.869 1.961 1.942"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 15.17)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "cv420fvlub",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lt90uyk94a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#D1E040",
    d: "M20.237.739H.464C.207.739 0 .944 0 1.198V4.04c0 .253.207.459.464.459h19.773c.255 0 .463-.206.463-.459V1.198c0-.254-.208-.46-.463-.46",
    mask: "url(#cv420fvlub)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarpentry);
export default __webpack_public_path__ + "static/media/carpentry.b771a1878ce683104a42c15fcdb6149a.svg";
export { ForwardRef as ReactComponent };